import React from "react";
import { connect } from "react-redux";
import {acceptTermsAndConditions, rejectTermsAndConditions} from "actions/login.js";
import LoginSwitch from "./LoginSwitch.jsx";

// mapStateToProps is a react-redux specific function
// that injects the redux store, after filters. REQUIRED
//    state = reduxStore
//    ownProps = props passed to container Component (Not Meteor data)
const mapStateToProps = (state, ownProps) => {
	// console.log(state);
	// console.log(ownProps);
	return {
		codeDeliveryMessage: state.login.codeDeliveryMessage,
		createNewPassword: state.login.createNewPassword,
		currentProject: state.login.currentProject,
		forceChangePassword: state.login.forceChangePassword,
		forgotPassword: state.login.forgotPassword,
		loggedIn: state.login.loggedIn,
		loginInputChangePasswordNew: state.login.loginInputChangePasswordNew,
		loginInputChangePasswordOld: state.login.loginInputChangePasswordOld,
		loginError: state.login.loginError,
		loginErrorText: state.login.loginErrorText,
		loginInputEmail: state.login.loginInputEmail,
		loginInputPassword: state.login.loginInputPassword,
		loginInputVerificationCode: state.login.loginInputVerificationCode,
		loginInputNewPassword: state.login.loginInputNewPassword,
		termsAndConditionsAccepted: state.login.termsAndConditionsAccepted,
		userJustLoggedIn: state.login.userJustLoggedIn,
		validationInProgress: state.login.validationInProgress
	};
};

// mapDispatchToProps is a react-redux specific
// function that binds a function into the props
// Default is: dispatch => ({ dispatch }), to this isn't necessary in simple uses
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		acceptTermsAndConditions: () => {
			dispatch(acceptTermsAndConditions());
		},
		rejectTermsAndConditions: () => {
			dispatch(rejectTermsAndConditions());
		},
		dispatch,
	};
};

// const mergeProps = ( stateProps, actionProps, parentProps ) => ({
// ...stateProps,
// ...actionProps,
// ...parentProps
// });

// Combines everything
const LoginContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	// mergeProps
)(LoginSwitch);

export default LoginContainer;
